function Card(props) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`frosted-glass !z-5 relative flex flex-col border rounded-[30px] bg-clip-border shadow-3xl shadow-shadow-500 dark:text-white dark:shadow-none ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
